export const WORKFLOW_SESSION_SOURCE = {
  PREVIEW: 'PREVIEW',
  REAL: 'REAL',
};
